import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {EmailSmsPlaceholderModalComponent} from "./email-sms-placeholder-modal.component";
import {EmailSmsPlaceholderModule} from "../email-sms-placeholder/email-sms-placeholder.module";
import {ButtonModule} from "@xref/xref-lib";

@NgModule({
  declarations: [EmailSmsPlaceholderModalComponent],
  imports: [
    CommonModule,
    EmailSmsPlaceholderModule,
    ButtonModule
  ],
  exports: [EmailSmsPlaceholderModalComponent]
})
export class EmailSmsPlaceholderModalModule { }
